(function () {
var DISCOUNT_CODE = 'T53P2HSVAT45';
var ACC_HANDLE = 'hitchfire-accessories-1';
var CHECKOUT_DISCOUNT = '/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=/checkout';
var accIds = null;
try {
var st = document.createElement('style');
st.textContent = 'lb-upsell-product-page-addon{display:none !important;}';
(document.head || document.documentElement).appendChild(st);
} catch (e) {}
try {
var _self = document.currentScript || document.querySelector('script[src*="hf-pdp-atc.js"]');
if (_self && _self.src && !document.querySelector('link[data-hf-swing-css]')) {
var _href = _self.src.replace(/hf-pdp-atc\.js.*$/, 'hf-swing-modal.css');
var _l = document.createElement('link');
_l.rel = 'stylesheet'; _l.href = _href; _l.setAttribute('data-hf-swing-css', '1');
(document.head || document.documentElement).appendChild(_l);
}
} catch (e) {}
function openCart() {
// Post-add: show the cross-sell popup (every add ends at checkout) instead of the
// cart drawer. Falls back to the drawer if hf-xsell.js hasn't loaded.
if (window.HFXsell && window.HFXsell.open) { try { window.HFXsell.open({ handle: currentHandle() }); return; } catch (e) {} }
var o = document.querySelector('[data-cart-open]'); if (o) o.click();
}
function digits(s) { if (s == null) return null; s = String(s).trim(); return /^\d{6,}$/.test(s) ? s : null; }
function loadAccIds() {
if (accIds) return Promise.resolve(accIds);
var cached;
try { cached = sessionStorage.getItem('hf_acc_ids'); } catch (e) {}
if (cached) { try { accIds = JSON.parse(cached); return Promise.resolve(accIds); } catch (e) {} }
return fetch('/collections/' + ACC_HANDLE + '/products.json?limit=250')
.then(function (r) { return r.json(); })
.then(function (d) {
accIds = {};
(d.products || []).forEach(function (p) { accIds[p.id] = 1; });
try { sessionStorage.setItem('hf_acc_ids', JSON.stringify(accIds)); } catch (e) {}
return accIds;
})
.catch(function () { accIds = {}; return accIds; });
}
function setCheckoutHref(href) {
var links = document.querySelectorAll('[data-cart-checkout]');
for (var i = 0; i < links.length; i++) if (links[i].tagName === 'A') links[i].setAttribute('href', href);
}
function syncCheckoutDiscount() {
Promise.all([
fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
loadAccIds()
]).then(function (res) {
var cart = res[0] || {}, ids = res[1] || {};
var hasAcc = (cart.items || []).some(function (it) { return ids[it.product_id]; });
setCheckoutHref(hasAcc ? CHECKOUT_DISCOUNT : '/checkout');
}).catch(function () {});
}
var _fetch = window.fetch;
if (typeof _fetch === 'function') {
window.fetch = function (input) {
var url = (input && input.url) ? input.url : String(input);
var p = _fetch.apply(this, arguments);
if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?($|\?|#)/.test(url)) {
p.then(function (res) { if (res && res.ok) setTimeout(syncCheckoutDiscount, 250); }, function () {});
}
return p;
};
}
function addToCart(id, qty, btn, props) {
var prev = btn ? btn.textContent : '';
if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
var payload = { id: parseInt(id, 10), quantity: qty || 1 };
if (props) { for (var k in props) { if (props.hasOwnProperty(k)) { payload.properties = props; break; } } }
return fetch('/cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify(payload)
}).then(function (r) { return r.json(); }).then(function () {
if (btn) { btn.disabled = false; btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = prev || 'Add to cart'; }, 1500); }
openCart();
}).catch(function () { if (btn) { btn.disabled = false; btn.textContent = prev || 'Add to cart'; } });
}
var NO_SWING_RX = /platform only|platform-only|box only|box-only|no swing|without swing|frame only|base only|deck only/i;
var CROSS_SELL = {
'ledge-platform-swing-arm-not-included': { recHandle: 'ledge-platform', recVariantId: 41698007318587, kind: 'platform' },
'hitchfire-f20-portable-tabletop-propane-grill': { recHandle: 'f-20', recVariantId: 41664997916731, kind: 'tabletop' },
'forge-15-tabletop-propane-grill': { recHandle: 'hitchfire-grill', recVariantId: 39565154418747, kind: 'tabletop' }
};
var decided = {};       // variant ids the shopper has already decided on (skip re-prompt)
var modalEl = null;
function money(c) { return '$' + (Number(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
function readJSON(sel) { var el = document.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
function pdpVariants() { return readJSON('[data-hf-variants]'); }
function pdpOptionNames() { return readJSON('[data-hf-options]'); }
function hasSwing(title) { title = String(title || ''); return /swing/i.test(title) && !/no\s*swing/i.test(title); }
function cssEsc(s) { if (window.CSS && CSS.escape) return CSS.escape(String(s)); return String(s).replace(/["\\]/g, '\\$&'); }
function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function currentHandle() { var m = (location.pathname || '').match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; }
function fetchProductJson(handle) {
return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
}
function findVariant(vs, id) { id = String(id); for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === id) return vs[i]; } return null; }
function swingSiblingFor(vs, cur) {
var curOpts = cur.options || [];
var cands = [];
for (var i = 0; i < vs.length; i++) { var v = vs[i]; if (v.available && hasSwing(v.title)) cands.push(v); }
if (!cands.length) return null;
cands.sort(function (a, b) {
var sa = 0, sb = 0, ao = a.options || [], bo = b.options || [], j;
for (j = 0; j < ao.length; j++) { if (ao[j] === curOpts[j]) sa++; }
for (j = 0; j < bo.length; j++) { if (bo[j] === curOpts[j]) sb++; }
if (sb !== sa) return sb - sa;
return (a.price || 0) - (b.price || 0);
});
return cands[0];
}
function reminderFor(vs, cur) {
if (!cur || hasSwing(cur.title)) return null;
var sib = swingSiblingFor(vs, cur);
if (!sib) return null;
if (NO_SWING_RX.test(cur.title) || vs.length === 2) return sib;
return null;
}
function selectVariantUI(variant, optionNames) {
if (!variant || !optionNames) return;
var opts = variant.options || [];
for (var i = 0; i < optionNames.length; i++) {
var val = opts[i];
if (val == null) continue;
var btn = document.querySelector('[data-hf-opt][data-option-name="' + cssEsc(optionNames[i]) + '"][data-option-value="' + cssEsc(val) + '"]');
if (btn && !btn.classList.contains('is-active')) btn.click();
}
}
function sameProductOffer(info) {
var cur = info.current, sib = info.sibling;
var noun = /box/i.test(cur.title) ? 'box' : 'platform';
var diff = Math.max(0, (sib.price || 0) - (cur.price || 0));
return {
eyebrow: 'Wait — don’t forget the swing arm',
headline: 'This option doesn’t include the Dual Swing Arm',
body: 'You’ve selected <strong>' + escapeHtml(cur.title) + '</strong> — that’s the ' + noun + ' on its own. It still needs the patented <strong>Dual Swing Arm</strong> to mount to your 2&quot; hitch and swing out for full tailgate access. Most customers add it.',
yourLabel: 'Your pick', yourTitle: cur.title, yourPrice: money(cur.price),
recLabel: 'Recommended', recTitle: sib.title, recPrice: money(sib.price), recNote: (diff > 0 ? '+' + money(diff) : ''),
upgradeLabel: 'Add With Dual Swing Arm · ' + money(sib.price) + ' →',
keepLabel: 'No thanks, I already have a swing arm'
};
}
function crossSellOffer(cfg, currentId) {
var handle = currentHandle();
return Promise.all([fetchProductJson(handle), fetchProductJson(cfg.recHandle)]).then(function (res) {
var cur = res[0], rec = res[1];
if (!rec) return null;
var recVar = (rec.variants || []).filter(function (v) { return String(v.id) === String(cfg.recVariantId); })[0] || (rec.variants || [])[0];
if (!recVar || recVar.available === false) return null;
var curVar = cur ? ((cur.variants || []).filter(function (v) { return String(v.id) === String(currentId); })[0] || (cur.variants || [])[0]) : null;
var curTitle = cur ? cur.title : ((document.querySelector('.pdp__title') || {}).textContent || 'this item');
var curPrice = curVar ? curVar.price : null;
var recPrice = recVar.price;
var diff = (curPrice != null) ? Math.max(0, recPrice - curPrice) : 0;
var d;
if (cfg.kind === 'tabletop') {
d = {
eyebrow: 'Wait — this is the tabletop version',
headline: 'This grill doesn’t mount to your hitch',
body: 'The <strong>' + escapeHtml(curTitle) + '</strong> is a standalone <strong>tabletop</strong> grill — it doesn’t mount to your hitch. Want the hitch-mounted version with the patented <strong>Dual Swing Arm</strong> instead? Same grill, mounts to your 2&quot; receiver and swings out for full tailgate access.',
recLabel: 'Hitch-mounted',
upgradeLabel: 'Get the hitch-mounted version · ' + money(recPrice) + ' →',
keepLabel: 'No thanks, I want the tabletop grill'
};
} else {
d = {
eyebrow: 'Wait — swing arm not included',
headline: 'This platform doesn’t include the swing arm',
body: 'The <strong>' + escapeHtml(curTitle) + '</strong> is the platform on its own — the Dual Swing Arm that mounts it to your 2&quot; hitch is sold separately. The <strong>' + escapeHtml(rec.title) + '</strong> comes with the patented <strong>Dual Swing Arm</strong> included, ready to mount.',
recLabel: 'Recommended',
upgradeLabel: 'Get the one with the swing arm · ' + money(recPrice) + ' →',
keepLabel: 'No thanks, platform only'
};
}
d.yourLabel = 'Your pick'; d.yourTitle = curTitle; d.yourPrice = (curPrice != null ? money(curPrice) : '');
d.recTitle = rec.title; d.recPrice = money(recPrice); d.recNote = (diff > 0 ? '+' + money(diff) : '');
d.recId = recVar.id;
return d;
});
}
function closeModal() {
if (!modalEl) return;
var el = modalEl; modalEl = null;
el.classList.remove('is-open');
document.body.style.overflow = '';
setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 220);
}
function showOffer(o) {
if (modalEl) return;
var wrap = document.createElement('div');
wrap.className = 'hfswing';
wrap.setAttribute('role', 'presentation');
wrap.innerHTML =
'<div class="hfswing__scrim" data-x></div>' +
'<div class="hfswing__dialog" role="dialog" aria-modal="true" aria-labelledby="hfswing-title">' +
'<button class="hfswing__x" type="button" data-x aria-label="Close">\u00d7</button>' +
'<div class="hfswing__eyebrow">' + escapeHtml(o.eyebrow || 'Wait — before you add') + '</div>' +
'<h2 class="hfswing__title" id="hfswing-title">' + escapeHtml(o.headline) + '</h2>' +
'<p class="hfswing__body">' + o.body + '</p>' +
'<div class="hfswing__compare">' +
'<div class="hfswing__opt">' +
'<span class="hfswing__opt-label">' + escapeHtml(o.yourLabel) + '</span>' +
'<span class="hfswing__opt-name">' + escapeHtml(o.yourTitle) + '</span>' +
'<span class="hfswing__opt-price">' + escapeHtml(o.yourPrice || '') + '</span>' +
'</div>' +
'<div class="hfswing__opt hfswing__opt--rec">' +
'<span class="hfswing__opt-label">' + escapeHtml(o.recLabel) + '</span>' +
'<span class="hfswing__opt-name">' + escapeHtml(o.recTitle) + '</span>' +
'<span class="hfswing__opt-price">' + escapeHtml(o.recPrice) + (o.recNote ? '<em>' + escapeHtml(o.recNote) + '</em>' : '') + '</span>' +
'</div>' +
'</div>' +
'<div class="hfswing__actions">' +
'<button class="hfswing__btn hfswing__btn--primary" type="button" data-upgrade>' + escapeHtml(o.upgradeLabel) + '</button>' +
'<button class="hfswing__btn hfswing__btn--ghost" type="button" data-keep>' + escapeHtml(o.keepLabel) + '</button>' +
'</div>' +
'</div>';
modalEl = wrap;
document.body.appendChild(wrap);
document.body.style.overflow = 'hidden';
void wrap.offsetWidth;
wrap.classList.add('is-open');
function onKey(e) { if (e.key === 'Escape') { dismiss(); } }
function dismiss() { document.removeEventListener('keydown', onKey); if (o.onDismiss) o.onDismiss(); closeModal(); }
document.addEventListener('keydown', onKey);
wrap.querySelectorAll('[data-x]').forEach(function (b) { b.addEventListener('click', dismiss); });
var up = wrap.querySelector('[data-upgrade]');
var keep = wrap.querySelector('[data-keep]');
if (up) up.addEventListener('click', function () { document.removeEventListener('keydown', onKey); closeModal(); o.onUpgrade(); });
if (keep) keep.addEventListener('click', function () { document.removeEventListener('keydown', onKey); closeModal(); o.onKeep(); });
setTimeout(function () { if (up) up.focus(); }, 40);
}
function currentReminder(id) {
var vs = pdpVariants();
if (!vs || !id) return null;
var cur = findVariant(vs, id);
if (!cur) return null;
var sib = reminderFor(vs, cur);
if (!sib) return null;
return { variants: vs, current: cur, sibling: sib, optionNames: pdpOptionNames() };
}
/* Line-item properties. This file rebuilds the cart POST from scratch instead of
   letting the form post itself, so ANYTHING named properties[...] is dropped
   unless collected here - including the pre-order acknowledgement and its ship
   date, which have to survive onto the order for fulfilment to honour them. */
function formProps(fd) {
var out = {};
fd.forEach(function (val, key) {
var m = /^properties\[(.+)\]$/.exec(key);
if (m && String(val).length) out[m[1]] = val;
});
return out;
}
/* Pre-order gate. The buy button is disabled until the shopper ticks the
   acknowledgement, but this handler acts on the submit EVENT and never looks at
   the button's disabled state, so Enter-to-submit would otherwise walk straight
   past the gate. Enforced here as well as in the UI. */
function preorderBlocked(form) {
var box = form.querySelector('[data-hf-preorder-box]');
if (!box || box.hidden) return false;
var ack = box.querySelector('[data-hf-preorder-ack]');
if (ack && ack.checked) return false;
try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
box.setAttribute('data-hf-nudge', '1');
setTimeout(function () { box.removeAttribute('data-hf-nudge'); }, 1200);
return true;
}
window.addEventListener('submit', function (e) {
var form = e.target && e.target.closest && e.target.closest('#product-atc-form, [data-atc-form]');
if (!form) return;
var fd = new FormData(form);
var id = digits(fd.get('id'));
if (!id) return;
e.preventDefault();
e.stopImmediatePropagation();
if (preorderBlocked(form)) return;
var props = formProps(fd);
var qty = parseInt(fd.get('quantity'), 10) || 1;
var btn = form.querySelector('[data-atc-btn]');
if (decided[id]) { addToCart(id, qty, btn, props); return; }
var info = currentReminder(id);
if (info) {
var d = sameProductOffer(info);
d.onUpgrade = function () { decided[id] = 1; selectVariantUI(info.sibling, info.optionNames); addToCart(info.sibling.id, qty, btn); };
d.onKeep = function () { decided[id] = 1; addToCart(id, qty, btn, props); };
d.onDismiss = function () { decided[id] = 1; };
showOffer(d);
return;
}
var cfg = CROSS_SELL[currentHandle()];
if (cfg) {
crossSellOffer(cfg, id).then(function (d2) {
if (!d2) { addToCart(id, qty, btn, props); return; }
d2.onUpgrade = function () { decided[id] = 1; addToCart(d2.recId, qty, btn); };
d2.onKeep = function () { decided[id] = 1; addToCart(id, qty, btn, props); };
d2.onDismiss = function () { decided[id] = 1; };
showOffer(d2);
});
return;
}
addToCart(id, qty, btn, props);
}, true);
window.addEventListener('click', function (e) {
var sp = e.target && e.target.closest && e.target.closest('[data-hf-shoppay]');
if (!sp) return;
var idInput = document.querySelector('#product-atc-form [name="id"]') || document.querySelector('[data-variant-id]');
var id = idInput ? digits(idInput.value) : null;
if (!id || decided[id]) return;
var info = currentReminder(id);
var cfg = info ? null : CROSS_SELL[currentHandle()];
if (!info && !cfg) return;
e.preventDefault();
e.stopImmediatePropagation();
var qtyInput = document.querySelector('#product-atc-form [name="quantity"]');
var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
var keepShopPay = function () {
decided[id] = 1;
var real = document.querySelector('.pdp__shoppay-real shop-pay-button') || document.querySelector('.pdp__shoppay-real button, .pdp__shoppay-real [role="button"]');
if (real && real.click) real.click();
};
if (info) {
var d = sameProductOffer(info);
d.onUpgrade = function () { decided[id] = 1; selectVariantUI(info.sibling, info.optionNames); addToCart(info.sibling.id, qty, null); };
d.onKeep = keepShopPay;
d.onDismiss = function () { decided[id] = 1; };
showOffer(d);
} else {
crossSellOffer(cfg, id).then(function (d2) {
if (!d2) { keepShopPay(); return; }
d2.onUpgrade = function () { decided[id] = 1; addToCart(d2.recId, qty, null); };
d2.onKeep = keepShopPay;
d2.onDismiss = function () { decided[id] = 1; };
showOffer(d2);
});
}
}, true);
syncCheckoutDiscount();
})();
